import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cc from 'classcat';
import { CSSProperties } from 'styled-components';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { ETeamNumber } from 'interfaces/sportsbook';
import { Container, Logo, Name } from './style';
import { GameInfo } from 'components/Shared/SportsbookSingleGame/Banner/style';
import { TeamLogo } from 'components/TeamLogo';
import './index.less';

type Props = {
  name?: string;
  logo?: boolean;
  size?: 'sm' | 'md' | 'lg';
  reverse?: boolean;
  nameStyle?: CSSProperties;
  teamNumber?: ETeamNumber;
  isNotESport?: boolean;
  teamId?: number;
  competition?: boolean;
  dontShowTitle?: boolean;
  whiteText?: boolean;
  entry?: {
    EntityId: number | string;
    GeneralInfoWDL?: Array<string>;
    Position?: number;
    Points?: number;
  };
  className?: string;
};

export const TeamCaption = (props: Props): ReactElement => {
  const [hasImage, setHasImage] = useState(false);
  const { t } = useTranslation();

  return (
    <Container
      className="teamLogoWrapper"
      reverse={props.reverse || false}
      size={props.size || 'sm'}
    >
      {props.logo && SpringConfigs.TEAM_LOGOS && (
        <Logo
          hasImage={hasImage}
          className={cc([
            'logo-simple',
            {
              [props.className || '']: props.className
            }
          ])}
        >
          <TeamLogo
            teamId={props.teamId}
            size={props.dontShowTitle ? 'md' : props.size || 'sm'}
            setHasImage={setHasImage}
            competition={props.competition}
            isHomeOrAway={props.teamNumber}
            isNotESport={props.isNotESport}
          >
            <span className="teamNameAsIcon">
              {props.name ? String(props.name).substr(0, 2).toUpperCase() : '-'}
            </span>
          </TeamLogo>
        </Logo>
      )}
      <div className="comp__teamName__wrapper">
        {!props.dontShowTitle && (
          <Name
            className="comp__team-name"
            whiteText={props.whiteText}
            style={props.nameStyle}
          >
            {props.name}
          </Name>
        )}
        {(props.entry?.Position || props.entry?.Points) && (
          <GameInfo>
            {`${
              props.entry?.Position &&
              `${t('sportsbook.position')}: ${props.entry?.Position} |`
            } ${
              props.entry?.Points &&
              `${t('sportsbook.point(s)')}: ${props.entry?.Points}`
            }`}
          </GameInfo>
        )}
      </div>
    </Container>
  );
};
